module.exports = __webpack_public_path__ + "img/jianding-b.808c519c.svg";